'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationHeader = function () {
    function WinresReservationHeader($scope, $timeout, localizationService, ownerService, regionService, productService, $filter) {
        _classCallCheck(this, WinresReservationHeader);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ownerService = ownerService;
        this.localizationService = localizationService;
        this.slides = [];
        this.regionService = regionService;
        this.region = "";
        this.productService = productService;
        this.$filter = $filter;
    }

    _createClass(WinresReservationHeader, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:

            // getContext()
            // getContext().futureReservations
            // getContext().pastReservations
            // getContext().selectedReservation
            // getContext().Destination
            // getUserReservations()
            // getOwnerData()

            if (!this.winresReservationContext) {
                if (window.definiteWinresReservationContext) {
                    console.log('[winres-reservation-header]', 'Context is not available. Falling back to global.');
                    this.winresReservationContext = window.definiteWinresReservationContext;
                } else {
                    throw new Error('A context is required.');
                }
            }

            this.data = this.winresReservationContext.getContext();

            if (this.imageSource == 'omaloma') {
                this.winresReservationContext.getUserReservations();

                this.$scope.$watch('$ctrl.data.selectedReservation', function () {
                    // console.log("CONDITIONAL HEADER", this.data);
                    // console.log(this.data.futureReservations);
                    // console.log(this.data.pastReservations);
                    if (_this.data.selectedReservation) {
                        _this.image = _this.data.selectedReservation.Image;
                        _this.headline = _this.showHeadline === 'false' ? '' : _this.data.selectedReservation.Headline;
                        _this.destName = _this.showName === 'false' ? '' : _this.data.selectedReservation.Subtitle;
                    }
                    _this.showHeader = true;
                });
            } else if (this.imageSource == 'owner') {
                console.log('[WRH] using owner info');
                this.winresReservationContext.getOwnerData().then(function (description) {
                    _this.description = description;
                    _this.image = _this.description.Images[0].Url;
                    _this.headline = _this.description.Note4;
                    _this.showHeader = true;
                });
            } else {
                this.$scope.$watch('$ctrl.data.Destination', function () {
                    if (_this.data.Destination) {
                        _this.image = _this.data.Destination.Images[0];
                        _this.headline = _this.showHeadline === 'false' ? '' : _this.data.Destination.Headline;
                        _this.destName = _this.showName === 'false' ? '' : _this.data.Destination.DestinationExtraName ? _this.data.Destination.DestinationExtraName : _this.data.Destination.DestinationName;

                        var language = _this.localizationService.getLanguage();

                        _this.regionService.getRegions(language).then(function (result) {
                            var regions = _.filter(result, function (region) {
                                return region.Code === _this.data.Destination.SubGroup;
                            });
                            if (regions.length > 0) _this.region = regions[0].Name;
                            _this.showHeader = true;

                            // Get header.
                            _this.getHeader(language);
                        });
                    }
                });
            }
        }
    }, {
        key: 'getHeader',
        value: function getHeader(language) {
            var _this2 = this;

            var urlParams = this.winresReservationContext.getUrlParams();

            this.productService.getReservableProduct(urlParams.DestinationCode, urlParams.ProductCode, language, 1).then(function (product) {
                if (product) {
                    if (_this2.showHeader && _this2.region) {
                        _this2.header = _this2.region;
                    } else if (_this2.data.Destination.Type === 'PA') {
                        _this2.header = _this2.$filter('i18next')('winres_departures.package');
                    } else if (product.DestinationInfo.Accommodation) {
                        _this2.header = _this2.$filter('i18next')('winres_departures.accommodation');
                    } else {
                        _this2.header = _this2.$filter('i18next')('winres_departures.service');
                    }
                }
            });
        }
    }]);

    return WinresReservationHeader;
}();

WinresReservationHeader.$inject = ['$scope', '$timeout', 'localizationService', 'ownerService', 'regionService', 'productService', '$filter'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'header';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('header', require('./winresReservationHeader.html'));
}]);

_module3.default.component('winresReservationHeader', {
    templateUrl: getTemplate,
    controller: WinresReservationHeader,
    bindings: {
        showName: '@', // 'true' (default) or 'false'
        showHeadline: '@', // 'true' (default) or 'false'
        imageSource: '@', // Image source. 'omaloma' or 'owner'. Leave empty to disable
        showIntClass1: '@' // 'true' or 'false' (default)
    },
    require: {
        winresReservationContext: '?^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationHeader/winresReservationHeader.js
// module id = 418
// module chunks = 2